/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 乗務リポート
 * @export
 * @interface ShiftReportsRow
 */
export interface ShiftReportsRow {
    /**
     * shift_start_date
     * @type {string}
     * @memberof ShiftReportsRow
     */
    shiftDate?: string;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof ShiftReportsRow
     */
    officeId?: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof ShiftReportsRow
     */
    officeName?: string;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof ShiftReportsRow
     */
    driverId?: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof ShiftReportsRow
     */
    driverName?: string;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof ShiftReportsRow
     */
    driverCode?: string;
    /**
     * 要指導休憩
     * @type {string}
     * @memberof ShiftReportsRow
     */
    needGuidanceBreaks?: string;
    /**
     * 要指導ナビ
     * @type {string}
     * @memberof ShiftReportsRow
     */
    needGuidanceHermes?: string;
    /**
     * 要指導営収
     * @type {string}
     * @memberof ShiftReportsRow
     */
    needGuidanceEarnings?: string;
    /**
     * 乗務時間（分）
     * @type {number}
     * @memberof ShiftReportsRow
     */
    shiftLengthMin?: number;
    /**
     * 休憩時間（分）
     * @type {number}
     * @memberof ShiftReportsRow
     */
    breaksLengthMin?: number;
    /**
     * 配車一時停止時間（分）
     * @type {number}
     * @memberof ShiftReportsRow
     */
    pauseCarRequestLengthMin?: number;
    /**
     * ナビ利用率
     * @type {number}
     * @memberof ShiftReportsRow
     */
    naviUsageRate?: number;
    /**
     * 時間営収
     * @type {number}
     * @memberof ShiftReportsRow
     */
    timeEarnings?: number;
    /**
     * 成果課金ユーザー判定
     * @type {number}
     * @memberof ShiftReportsRow
     */
    paymentMethod?: number;
}

export function ShiftReportsRowFromJSON(json: any): ShiftReportsRow {
    return ShiftReportsRowFromJSONTyped(json, false);
}

export function ShiftReportsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftReportsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftDate': !exists(json, 'shift_date') ? undefined : json['shift_date'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeName': !exists(json, 'office_name') ? undefined : json['office_name'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'needGuidanceBreaks': !exists(json, 'need_guidance_breaks') ? undefined : json['need_guidance_breaks'],
        'needGuidanceHermes': !exists(json, 'need_guidance_hermes') ? undefined : json['need_guidance_hermes'],
        'needGuidanceEarnings': !exists(json, 'need_guidance_earnings') ? undefined : json['need_guidance_earnings'],
        'shiftLengthMin': !exists(json, 'shift_length_min') ? undefined : json['shift_length_min'],
        'breaksLengthMin': !exists(json, 'breaks_length_min') ? undefined : json['breaks_length_min'],
        'pauseCarRequestLengthMin': !exists(json, 'pause_car_request_length_min') ? undefined : json['pause_car_request_length_min'],
        'naviUsageRate': !exists(json, 'navi_usage_rate') ? undefined : json['navi_usage_rate'],
        'timeEarnings': !exists(json, 'time_earnings') ? undefined : json['time_earnings'],
        'paymentMethod': !exists(json, 'payment_method') ? undefined : json['payment_method'],
    };
}

export function ShiftReportsRowToJSON(value?: ShiftReportsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_date': value.shiftDate,
        'office_id': value.officeId,
        'office_name': value.officeName,
        'driver_id': value.driverId,
        'driver_name': value.driverName,
        'driver_code': value.driverCode,
        'need_guidance_breaks': value.needGuidanceBreaks,
        'need_guidance_hermes': value.needGuidanceHermes,
        'need_guidance_earnings': value.needGuidanceEarnings,
        'shift_length_min': value.shiftLengthMin,
        'breaks_length_min': value.breaksLengthMin,
        'pause_car_request_length_min': value.pauseCarRequestLengthMin,
        'navi_usage_rate': value.naviUsageRate,
        'time_earnings': value.timeEarnings,
        'payment_method': value.paymentMethod,
    };
}


